import { NanaeHeader, NanaeFooter } from "@/components/qv3/NanaeShared";

export type ErrorPageCTA = {
  label: string;
  onClick: () => void;
  variant: "primary" | "outline";
};

type Props = {
  code: "404" | "500";
  eyebrow: string;
  sub: string;
  ctas: ErrorPageCTA[];
};

const ctaBase = (variant: "primary" | "outline"): React.CSSProperties => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "14px 28px",
  fontFamily: '"DM Mono", monospace',
  fontSize: 11,
  letterSpacing: "2px",
  textTransform: "uppercase",
  fontWeight: variant === "primary" ? 700 : 500,
  cursor: "pointer",
  border: variant === "primary" ? "none" : "0.5px solid var(--charcoal)",
  background: variant === "primary" ? "var(--accent-cramoisi)" : "transparent",
  color: "var(--charcoal)",
  transition: "background-color 120ms, border-color 120ms",
});

export function ErrorPage({ code, eyebrow, sub, ctas }: Props) {
  return (
    <div className="nanae-page" style={{ background: "var(--ivory)", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <NanaeHeader title={code === "404" ? "Page introuvable" : "Erreur"} variant="public" />
      <section
        aria-label="Page d'erreur"
        data-rp="error-section"
        style={{
          maxWidth: 720,
          margin: "0 auto",
          padding: "80px 32px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            marginBottom: 24,
          }}
        >
          <span
            aria-hidden
            style={{ width: 24, height: 0.5, background: "var(--accent-cramoisi)", display: "inline-block" }}
          />
          <span
            style={{
              fontFamily: '"DM Mono", monospace',
              fontSize: 11,
              color: "var(--leather)",
              letterSpacing: "3px",
              textTransform: "uppercase",
            }}
          >
            {eyebrow}
          </span>
        </div>
        <h1
          id="error-page-code"
          style={{
            fontFamily: '"Anton", sans-serif',
            fontWeight: 400,
            fontSize: "clamp(120px, 18vw, 200px)",
            color: "var(--charcoal)",
            letterSpacing: "-4px",
            lineHeight: 0.85,
            margin: 0,
          }}
        >
          {code}
        </h1>
        <p
          style={{
            fontFamily: '"Cormorant Garamond", Georgia, serif',
            fontStyle: "italic",
            fontWeight: 500,
            fontSize: "clamp(22px, 3vw, 30px)",
            color: "var(--gold-deep)",
            lineHeight: 1.3,
            margin: "24px auto 56px",
            maxWidth: 540,
          }}
        >
          {sub}
        </p>
        <div
          data-rp="error-ctas"
          style={{
            display: "inline-flex",
            gap: 16,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {ctas.map((c) => (
            <button
              key={c.label}
              type="button"
              onClick={c.onClick}
              style={ctaBase(c.variant)}
            >
              {c.label}
            </button>
          ))}
        </div>
      </section>
      <NanaeFooter variant="minimal" />
    </div>
  );
}
